import React from 'react';
import clsx from 'clsx';
import Text from '@/components/ui/Text';
import { ISearchResult } from '../types';

const SearchResult = ({ body, truncateResults }: ISearchResult) => (
  <Text size="sm" variant="body" weight="normal">
    <span
      className={clsx(
        'tw-py-1',
        { 'tw-line-clamp-3': truncateResults },
      )}
      dangerouslySetInnerHTML={{ __html: `${body}…` }}
    />
  </Text>
);

export { default as ImageModel } from './ImageModel';
export default SearchResult;
